import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import lodashMap from 'lodash/map';
import lodashGet from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';

import * as actions from '../../actions';
import * as Constants from '../../constants';
import EmptyCart from './EmptyCart';
import CartMedicineContainer from '../../components/Cart/CartMedicineContainer';
import CartHealthcareContainer from '../../components/Cart/CartHealthcareContainer';
import CartFooter from '../../components/Cart/CartFooter';

import './Cart.scss';

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canPlaceOrder: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { cart: { action } } = this.props;
    const oldType = prevProps.cart.action ? prevProps.cart.action.type : undefined;
    if (!action || (action.type === oldType)) {
      return;
    }


    switch (action.type) {
      case Constants.SELECT_ADDRESS_SUCCESS:
      case Constants.SET_PROMOCODE_SUCCESS:
      case Constants.ADD_TO_CART_SUCCESS:
      case Constants.UPDATE_CART_SUCCESS:
      case Constants.PLACE_REORDER_SUCCESS:
      case Constants.RESET_PROMOCODE:
        if (this.props.customer.omsEnabled) {
          this.props.actions.getCartItemsV5();
          this.props.actions.getLoyaltyData({ custom_token: 'profile' });
        } else {
          this.props.actions.getCartItems();
        }
        break;
      default:
        // no-op
    }
  }

  handleCartUpdate(itemId, quantity) {
    if (!quantity) return;
    return this.props.actions.updateCart({ itemId, quantity });
  }

  handleCartItemRemove = async itemId => {
    const resp = await this.props.actions.removeFromCart({ itemId });
    if (this.props.customer.omsEnabled) {
      this.props.actions.getCartItemsV5();
    } else {
      this.props.actions.getCartItems();
    }

    return resp;
  }

  handleLPRemove = () => {
    this.props.actions.removeLoyaltyData();
    this.props.actions.getCartItemsV5();
  }

  onLPVariantUpdate = selectedVariant => {
    // eslint-disable-next-line eqeqeq
    const variantSelected = this.props.loyalty.variants.find(variant => variant.id == selectedVariant.value);
    this.props.actions.setLoyaltyData(variantSelected);
    this.props.actions.getCartItemsV5();
  }

  render() {
    const { cart, productIdsWithRxAvailable = [], loyalty, selectedVariant } = this.props;

    if ((isEmpty(cart) || !cart.data || !cart.data.itemsCount) && !cart.loading) {
      return <EmptyCart />;
    }

    if (this.props.customer.omsEnabled) {
      const {
        itemsCount,
        items,
        amountBifurcation,
        pldDiscountBuckets = [],
        loyaltyDetailsPitch,
        loyaltyItem: cartLoyaltyItem,
        savingsBifurcation
      } = cart.data;

      const pld = isEmpty(pldDiscountBuckets) ? [] : pldDiscountBuckets;


      return (
        <div
          className={cx('CartContainer', {
            'pe-loading': cart.loading,
          })}
        >
          <div className="CartContent">
            <CartMedicineContainer
              medicineList={items}
              medicineAmountBifurcation={amountBifurcation}
              extraChargesBifurcation={[]}
              updateCart={(itemId, quantity) => this.handleCartUpdate(itemId, quantity)}
              onRemove={this.handleCartItemRemove}
              productIdsWithRxAvailable={productIdsWithRxAvailable}
              omsEnabled={this.props.customer.omsEnabled}
              loyaltyItem={loyalty}
              selectedLPVariant={selectedVariant}
              handleLPRemove={this.handleLPRemove}
              onLPVariantUpdate={this.onLPVariantUpdate}
              cartLoyaltyItem={cartLoyaltyItem}
              savingsBifurcationData={savingsBifurcation}
            />
          </div>
          <CartFooter
            itemsCount={itemsCount}
            total={amountBifurcation && amountBifurcation[amountBifurcation.length - 1][0].finalValue}
            pldDiscountBuckets={pld}
            loyaltyDetailsPitch={loyaltyDetailsPitch}
            loyalty={loyalty}
            selectedLPVariant={selectedVariant}
          />
        </div>
      );
    }
    const {
        itemsCount,
        medicine: {
          items: medicineItems = []
        } = {},
        healthcare: {
          items: healthcareItems = []
        } = {},
        medicineAmountBifurcation,
        amountBifurcation,
        reviewBifurcation,
        extraCharges,
      } = cart.data;

    let total = 0;
    if (reviewBifurcation && reviewBifurcation.length) {
      total = reviewBifurcation.reduce((sum, current) => (sum + Number(current.value)), 0);
    }
    const extraChargesBifurcation = lodashMap(extraCharges, item => item) || [];

    return (
      <div
        className={cx('CartContainer', {
          'pe-loading': cart.loading,
        })}
      >
        <div className="CartContent">
          {(medicineItems.length > 0) &&
          <CartMedicineContainer
            medicineList={medicineItems}
            medicineAmountBifurcation={medicineAmountBifurcation}
            extraChargesBifurcation={extraChargesBifurcation}
            updateCart={(itemId, quantity) => this.handleCartUpdate(itemId, quantity)}
            onRemove={this.handleCartItemRemove}
            productIdsWithRxAvailable={productIdsWithRxAvailable}
          />}
          {(healthcareItems.length > 0) &&
          <CartHealthcareContainer
            healthcareList={healthcareItems}
            amountBifurcation={amountBifurcation}
            updateCart={(itemId, quantity) => this.handleCartUpdate(itemId, quantity)}
            onRemove={this.handleCartItemRemove}
            omsEnabled={this.props.customer.omsEnabled}
          />}
        </div>
        <CartFooter itemsCount={itemsCount} total={total} />
      </div>
    );
  }
}

Cart.propTypes = {
  cart: PropTypes.object,
  actions: PropTypes.object,
  loyalty: PropTypes.object
};

Cart.defaultProps = {
  cart: {},
  actions: {},
  loyalty: {}
};

export default connect(state => ({
  cart: state.cart,
  loyalty: state.loyalty.data.profile,
  selectedVariant: state.loyalty.selectedVariant,
  orderParams: state.orderParams,
  action: state.action,
  gateways: state.gateways,
  productIdsWithRxAvailable: lodashGet(state.customer, 'customerDetails.data.profile.productIdsWithRxAvailable', []),
  customer: state.customer,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(Cart);
